















import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import { nonZeroNumberOnlyRules } from "@/forms/validation/numbers";
import { Products, SplitRowEvent } from "./splitRow.interface";

@Component<SplitRow164>({})
export default class SplitRow164 extends Vue {
  @Prop({ required: true })
  formatter!: Intl.NumberFormat;

  @Prop({ required: true })
  product!: Products;

  @Prop({ required: true })
  ratio!: number;

  localValue = 0
  discount = 0

  get clientPaysNumber() {
    return this.localValue / this.ratio
  }

  get clientPays() {
    if (!this.localValue) return ''
    return this.formatter.format(this.clientPaysNumber)
  }

  get valueAfterDiscountNumber() {
    return this.localValue / (1 - this.discount / 100);
  }

  get valueAfterDiscount() {
    return this.formatter.format(this.valueAfterDiscountNumber);
  }

  @Watch("localValue")
  @Watch("discount")
  onChange() {
    const obj: SplitRowEvent = {
      value: this.localValue,
      clientPays: this.clientPaysNumber,
      discount: this.discount,
      effectiveDiscount: this.effectiveDiscount,
      casualRateValue: this.valueAfterDiscountNumber,
      product: this.product
    };
    this.$emit("change", obj);
    return obj;
  }

  get effectiveDiscountNumber() {
    if (!this.localValue) return 0;
    const discount = 1 - this.clientPaysNumber / this.valueAfterDiscountNumber;
    return 100 * discount;
  }

  get effectiveDiscount() {
    if (!this.effectiveDiscountNumber) return "";
    return `${this.effectiveDiscountNumber.toFixed(1)}%`;
  }
}
